import React from 'react';
import HotelHeader from './HotelHeader';
import QuickAccessSection from './QuickAccessSection';
import CompetitorsSection from './competitors/CompetitorsSection';
import ServiceScrapingSection from './serviceScraping/ServiceScrapingSection';

const HotelPresentationMain = () => {
    return (
        <div className='hotel-presentation__main'>
            <HotelHeader />
            <QuickAccessSection />
            <ServiceScrapingSection />
            <CompetitorsSection />
        </div>
    );
};

export default HotelPresentationMain;
